const GROUPS_COLLECTION = 'groups';
const PASSOWRDS_COLLECTION = 'passwords';
const PASSWORD_LINKs = 'password-links';

export {
    GROUPS_COLLECTION,
    PASSOWRDS_COLLECTION,
    PASSWORD_LINKs
}